export default __webpack_public_path__ + "static/devices-set-3-6880c01a665ed1434832cdf3ce82ecfb.png";